"use strict";

define('uikit/collections/search.results',['underscore', 'jquery', 'marionette', '../mixins/component.mixin', '../templates'], function (_, $, Mn, ComponentMixin, Templates) {
  var ResultView = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'result',
    options: {
      active: false,
      description: '',
      text: ''
    },
    update: {
      active: false
    },
    triggers: {
      'mousedown': 'selected'
    },
    template: Templates.UIKit['result'],
    updateAttributes: function updateAttributes() {
      this.addClass('active', this.getBoolOption('active'));
    }
  });
  var SearchResults = Mn.CollectionView.extend(ComponentMixin).extend({
    className: 'results',
    childView: ResultView,
    options: {
      collection: null,
      empty: true
    },
    initialize: function initialize() {
      ComponentMixin.initialize.apply(this, arguments);
      this.updateEmptyProperty();
      this.listenTo(this, 'add:child remove:child render:collection', _.debounce(this.selectFirstResult));
    },
    getSelected: function getSelected() {
      return this.active;
    },
    onChildviewSelected: function onChildviewSelected(v) {
      this.selectResult(v._index);
      this.triggerMethod('result:selected', v);
    },
    selectResult: function selectResult(index, ignoreSet) {
      var result = null;
      if (this.collection && this.collection.models[index]) {
        result = this.children.findByModel(this.collection.models[index]);
      }
      this.children.without(result).forEach(function (c) {
        c.active = false;
      });
      if (result) {
        result.active = true;
        this.scrollResultIntoView(result);
      }
      this.active = result;
      if (!ignoreSet) {
        this.triggerMethod('result:active', result);
      }
    },
    scrollResultIntoView: function scrollResultIntoView(result) {
      var itemHeight = result.$el.outerHeight(),
        itemPosTop = result.$el.position().top,
        itemPosBottom = itemPosTop + itemHeight,
        listHeight = this.$el.height(),
        listScrollTop = this.$el.scrollTop();
      if (itemPosBottom > listHeight) {
        var scrollMore = itemHeight - (listHeight - itemPosTop);
        this.$el.scrollTop(listScrollTop + scrollMore);
      } else if (itemPosTop < 0) {
        this.$el.scrollTop(listScrollTop + itemPosTop);
      }
    },
    selectNextResult: function selectNextResult() {
      var active = this.active,
        index = 0;
      if (active) {
        index = this.collection.indexOf(active.model) + 1;
      }
      if (index < this.children.length) {
        this.selectResult(index);
      }
    },
    selectPreviousResult: function selectPreviousResult() {
      var active = this.active,
        index = null;
      if (active) {
        index = this.collection.indexOf(active.model) - 1;
      }
      this.selectResult(index);
    },
    selectFirstResult: function selectFirstResult() {
      this.active = null;
      if (!_.isEmpty(this.collection)) {
        this.selectResult(0, true);
      }
    },
    onChangeCollection: function onChangeCollection(self, newCollection, oldCollection) {
      this.$el.scrollTop(0);
      if (oldCollection) {
        this.stopListening(oldCollection);
      }
      if (this.collection) {
        this.listenTo(this.collection, 'add remove reset update', _.debounce(this.updateEmptyProperty));
      }
      this.updateEmptyProperty();
    },
    updateEmptyProperty: function updateEmptyProperty() {
      this.empty = !this.collection || this.collection.isEmpty();
    },
    updateAttributes: function updateAttributes() {
      this.addClass('empty', this.getBoolOption('empty'));
    }
  });
  SearchResults.Result = ResultView;
  return SearchResults;
});

